/**
 * El comprobante de la transaccion, en la pantalla de confirmacion (PAG-04).
 *
 * No es decoracion: Transbank exige que la pantalla de resultado muestre estos
 * datos para certificar la integracion, y sin la certificacion no entrega las
 * credenciales de produccion. Son la orden de compra, el nombre del comercio,
 * el monto y su moneda, el codigo de autorizacion, la fecha, el tipo de pago,
 * las cuotas, los ultimos cuatro digitos de la tarjeta y que se compro.
 *
 * Los datos llegan del backend y solo con el token de la transaccion
 * (`RespuestaConfirmacionPedido.comprobante`). El nombre del comercio y la
 * moneda no viajan por la red: son fijos del sitio. Lo que se compro, que
 * tambien es obligatorio, no se repite aca: lo lista el ticket de arriba, con
 * las mismas lineas de este comprobante.
 */
import type { ComprobantePago } from '@bandu/compartido';

import { SITIO } from '../../configuracion/sitio';
import { fechaHora, pesos } from '../../utilidades/formato';

export interface ComprobanteProps {
  comprobante: ComprobantePago;
}

export function Comprobante({ comprobante }: ComprobanteProps) {
  return (
    <section className="comprobante" aria-labelledby="comprobante-titulo">
      <h2 id="comprobante-titulo">Comprobante de la transacción</h2>

      <dl className="comprobante-datos">
        <div>
          <dt>Comercio</dt>
          <dd>{SITIO.nombreLargo}</dd>
        </div>
        <div>
          <dt>Orden de compra</dt>
          <dd className="mono">{comprobante.ordenCompra}</dd>
        </div>
        <div>
          <dt>Código de autorización</dt>
          <dd className="mono">{comprobante.codigoAutorizacion}</dd>
        </div>
        <div>
          <dt>Fecha de la transacción</dt>
          <dd>{fechaHora(comprobante.fechaTransaccion)}</dd>
        </div>
        <div>
          <dt>Tipo de pago</dt>
          <dd>{comprobante.tipoPago}</dd>
        </div>
        <div>
          <dt>Cuotas</dt>
          <dd>{comprobante.cuotas}</dd>
        </div>
        <div>
          <dt>Tarjeta</dt>
          <dd className="mono">•••• {comprobante.ultimosDigitosTarjeta}</dd>
        </div>
        <div>
          <dt>Monto</dt>
          <dd>{pesos(comprobante.montoAutorizado)} CLP</dd>
        </div>
      </dl>
    </section>
  );
}
